import React from 'react';
import { Box } from '@mui/material';
import LoginSsoForm from './login-sso-form';
import { LoadingOverlay } from '../../../components/abc/loading-overlay/loading-overlay';
import { LoginDobForm } from './login-dob-form';
import { LoginPageInfo } from './login-page-info';
import { ElementZIndexOrdering } from '../../../component_library/utils/element-z-iIndex-ordering';
import AlertBannerBox from '../../../components/abc/alert-banners/alert-banners-box';
import HeaderWithLogoOnly from '../../../components/abc/header/header-with-logo-only';
import {
  FullPageHeightWrapper,
  FullPageWidthWrapper,
  GridContainer,
  GridItem,
} from '../../../component_library/components/Grid';
import Footer, {
  FooterDisplayMode,
} from '../../../components/abc/footer/footer';
import useLoginPage from './hooks/use-login-page';

export const LoginPage: React.FC = () => {
  const {
    theme,
    isMobile,
    isTabletMini,
    data,
    loading,
    error,
    isInitialDataLoaded,
    loginMethod,
    routeToLoginPage,
    filterAlerts,
  } = useLoginPage();

  if (!isInitialDataLoaded || loading) {
    return <LoadingOverlay />;
  }

  if (error || !data) {
    return null;
  }

  const info = (
    <LoginPageInfo
      returnUrl={loginMethod ? routeToLoginPage : undefined}
      data={data}
      theme={theme}
      isTabletMini={isTabletMini}
      isMobile={isMobile}
    />
  );

  return (
    <FullPageHeightWrapper isPageContentCentered theme={theme}>
      <Box
        sx={{
          width: '100%',
          position: 'sticky',
          top: 0,
          zIndex: ElementZIndexOrdering.HEADER_WITH_ALERT_BANNER_WRAPPER,
        }}
      >
        <AlertBannerBox extraAlertsFilter={filterAlerts} />
      </Box>
      <HeaderWithLogoOnly isLogoInCenter />
      <FullPageWidthWrapper sx={{ marginBottom: isMobile ? '8px' : '24px' }}>
        <GridContainer
          justifyContent={
            isMobile || isTabletMini ? 'center' : 'space-between'
          }
        >
          {!isMobile && !isTabletMini && (
            <GridItem
              size={{
                desktop: 4.5,
                tablet: 6,
              }}
              sx={{ width: '450px', maxWidth: '55%' }}
            >
              {info}
            </GridItem>
          )}
          <GridItem
            size={{
              desktop: 4,
              tablet: 5.2,
              tabletMini: 6,
              mobile: 4,
            }}
          >
            {loginMethod ? (
              <LoginDobForm loginMethod={loginMethod} />
            ) : (
              <LoginSsoForm />
            )}
            {(isMobile || isTabletMini) && (
              <Box sx={{ marginTop: '48px' }}>{info}</Box>
            )}
          </GridItem>
        </GridContainer>
      </FullPageWidthWrapper>
      <Footer mode={FooterDisplayMode.LightFullWidth} />
    </FullPageHeightWrapper>
  );
};
